/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Experience } from './Experience';
import {
    ExperienceFromJSON,
    ExperienceFromJSONTyped,
    ExperienceToJSON,
} from './Experience';
import type { ManagementExperienceItem } from './ManagementExperienceItem';
import {
    ManagementExperienceItemFromJSON,
    ManagementExperienceItemFromJSONTyped,
    ManagementExperienceItemToJSON,
} from './ManagementExperienceItem';
import type { PersonalCompetence } from './PersonalCompetence';
import {
    PersonalCompetenceFromJSON,
    PersonalCompetenceFromJSONTyped,
    PersonalCompetenceToJSON,
} from './PersonalCompetence';
import type { SalaryLevelsItem } from './SalaryLevelsItem';
import {
    SalaryLevelsItemFromJSON,
    SalaryLevelsItemFromJSONTyped,
    SalaryLevelsItemToJSON,
} from './SalaryLevelsItem';
import type { SelectedDriverLicenses } from './SelectedDriverLicenses';
import {
    SelectedDriverLicensesFromJSON,
    SelectedDriverLicensesFromJSONTyped,
    SelectedDriverLicensesToJSON,
} from './SelectedDriverLicenses';
import type { SelectedITSkills } from './SelectedITSkills';
import {
    SelectedITSkillsFromJSON,
    SelectedITSkillsFromJSONTyped,
    SelectedITSkillsToJSON,
} from './SelectedITSkills';
import type { SelectedLanguages } from './SelectedLanguages';
import {
    SelectedLanguagesFromJSON,
    SelectedLanguagesFromJSONTyped,
    SelectedLanguagesToJSON,
} from './SelectedLanguages';
import type { UserPersonalData } from './UserPersonalData';
import {
    UserPersonalDataFromJSON,
    UserPersonalDataFromJSONTyped,
    UserPersonalDataToJSON,
} from './UserPersonalData';

/**
 * 
 * @export
 * @interface CandidateProfile
 */
export interface CandidateProfile {
    /**
     * 
     * @type {string}
     * @memberof CandidateProfile
     */
    id?: string;
    /**
     * 
     * @type {UserPersonalData}
     * @memberof CandidateProfile
     */
    personalData?: UserPersonalData;
    /**
     * 
     * @type {Array<number>}
     * @memberof CandidateProfile
     */
    competences?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CandidateProfile
     */
    jobTypes?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CandidateProfile
     */
    jobGoals?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof CandidateProfile
     */
    mobility?: number;
    /**
     * 
     * @type {number}
     * @memberof CandidateProfile
     */
    educationLevelId?: number;
    /**
     * 
     * @type {Array<SelectedLanguages>}
     * @memberof CandidateProfile
     */
    languages?: Array<SelectedLanguages>;
    /**
     * 
     * @type {Array<SelectedITSkills>}
     * @memberof CandidateProfile
     */
    itCompetences?: Array<SelectedITSkills>;
    /**
     * 
     * @type {Array<SelectedDriverLicenses>}
     * @memberof CandidateProfile
     */
    driverLicenses?: Array<SelectedDriverLicenses>;
    /**
     * 
     * @type {Array<PersonalCompetence>}
     * @memberof CandidateProfile
     */
    personalCompetences?: Array<PersonalCompetence>;
    /**
     * 
     * @type {string}
     * @memberof CandidateProfile
     */
    candidateTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateProfile
     */
    summary?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateProfile
     */
    personalProfile?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CandidateProfile
     */
    imageSet?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CandidateProfile
     */
    imageOnNetworkProfile?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CandidateProfile
     */
    imageOnJobProfile?: boolean;
    /**
     * 
     * @type {Experience}
     * @memberof CandidateProfile
     */
    experience?: Experience;
    /**
     * 
     * @type {ManagementExperienceItem}
     * @memberof CandidateProfile
     */
    managementExperience?: ManagementExperienceItem;
    /**
     * 
     * @type {Array<number>}
     * @memberof CandidateProfile
     */
    jobFunctions?: Array<number>;
    /**
     * 
     * @type {SalaryLevelsItem}
     * @memberof CandidateProfile
     */
    salaryLevel?: SalaryLevelsItem;
}

/**
 * Check if a given object implements the CandidateProfile interface.
 */
export function instanceOfCandidateProfile(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CandidateProfileFromJSON(json: any): CandidateProfile {
    return CandidateProfileFromJSONTyped(json, false);
}

export function CandidateProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): CandidateProfile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'personalData': !exists(json, 'PersonalData') ? undefined : UserPersonalDataFromJSON(json['PersonalData']),
        'competences': !exists(json, 'Competences') ? undefined : json['Competences'],
        'jobTypes': !exists(json, 'JobTypes') ? undefined : json['JobTypes'],
        'jobGoals': !exists(json, 'JobGoals') ? undefined : json['JobGoals'],
        'mobility': !exists(json, 'Mobility') ? undefined : json['Mobility'],
        'educationLevelId': !exists(json, 'EducationLevelId') ? undefined : json['EducationLevelId'],
        'languages': !exists(json, 'Languages') ? undefined : ((json['Languages'] as Array<any>).map(SelectedLanguagesFromJSON)),
        'itCompetences': !exists(json, 'ItCompetences') ? undefined : ((json['ItCompetences'] as Array<any>).map(SelectedITSkillsFromJSON)),
        'driverLicenses': !exists(json, 'DriverLicenses') ? undefined : ((json['DriverLicenses'] as Array<any>).map(SelectedDriverLicensesFromJSON)),
        'personalCompetences': !exists(json, 'PersonalCompetences') ? undefined : ((json['PersonalCompetences'] as Array<any>).map(PersonalCompetenceFromJSON)),
        'candidateTitle': !exists(json, 'CandidateTitle') ? undefined : json['CandidateTitle'],
        'summary': !exists(json, 'Summary') ? undefined : json['Summary'],
        'personalProfile': !exists(json, 'PersonalProfile') ? undefined : json['PersonalProfile'],
        'imageSet': !exists(json, 'ImageSet') ? undefined : json['ImageSet'],
        'imageOnNetworkProfile': !exists(json, 'ImageOnNetworkProfile') ? undefined : json['ImageOnNetworkProfile'],
        'imageOnJobProfile': !exists(json, 'ImageOnJobProfile') ? undefined : json['ImageOnJobProfile'],
        'experience': !exists(json, 'Experience') ? undefined : ExperienceFromJSON(json['Experience']),
        'managementExperience': !exists(json, 'ManagementExperience') ? undefined : ManagementExperienceItemFromJSON(json['ManagementExperience']),
        'jobFunctions': !exists(json, 'JobFunctions') ? undefined : json['JobFunctions'],
        'salaryLevel': !exists(json, 'SalaryLevel') ? undefined : SalaryLevelsItemFromJSON(json['SalaryLevel']),
    };
}

export function CandidateProfileToJSON(value?: CandidateProfile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'PersonalData': UserPersonalDataToJSON(value.personalData),
        'Competences': value.competences,
        'JobTypes': value.jobTypes,
        'JobGoals': value.jobGoals,
        'Mobility': value.mobility,
        'EducationLevelId': value.educationLevelId,
        'Languages': value.languages === undefined ? undefined : ((value.languages as Array<any>).map(SelectedLanguagesToJSON)),
        'ItCompetences': value.itCompetences === undefined ? undefined : ((value.itCompetences as Array<any>).map(SelectedITSkillsToJSON)),
        'DriverLicenses': value.driverLicenses === undefined ? undefined : ((value.driverLicenses as Array<any>).map(SelectedDriverLicensesToJSON)),
        'PersonalCompetences': value.personalCompetences === undefined ? undefined : ((value.personalCompetences as Array<any>).map(PersonalCompetenceToJSON)),
        'CandidateTitle': value.candidateTitle,
        'Summary': value.summary,
        'PersonalProfile': value.personalProfile,
        'ImageSet': value.imageSet,
        'ImageOnNetworkProfile': value.imageOnNetworkProfile,
        'ImageOnJobProfile': value.imageOnJobProfile,
        'Experience': ExperienceToJSON(value.experience),
        'ManagementExperience': ManagementExperienceItemToJSON(value.managementExperience),
        'JobFunctions': value.jobFunctions,
        'SalaryLevel': SalaryLevelsItemToJSON(value.salaryLevel),
    };
}

